import { render, staticRenderFns } from "./TooltipBase.vue?vue&type=template&id=2d6156de&scoped=true"
import script from "./TooltipBase.vue?vue&type=script&lang=js"
export * from "./TooltipBase.vue?vue&type=script&lang=js"
import style0 from "./TooltipBase.vue?vue&type=style&index=0&id=2d6156de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6156de",
  null
  
)

export default component.exports